import React from 'react';
import { useResponsiveImage } from '../hooks/useResponsiveImage';

interface ResponsiveImageProps {
  desktopSrc: string;
  mobileSrc: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Responsive image component that automatically switches between desktop and mobile images
 */
const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  desktopSrc,
  mobileSrc,
  alt,
  className = '',
  style,
}) => {
  const imageSrc = useResponsiveImage(desktopSrc, mobileSrc);

  return <img src={imageSrc} alt={alt} className={className} style={style} />;
};

export default ResponsiveImage;
